import { render, staticRenderFns } from "./NotFoundGuard.vue?vue&type=template&id=53dfac76&"
import script from "./NotFoundGuard.vue?vue&type=script&lang=js&"
export * from "./NotFoundGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53dfac76')) {
      api.createRecord('53dfac76', component.options)
    } else {
      api.reload('53dfac76', component.options)
    }
    module.hot.accept("./NotFoundGuard.vue?vue&type=template&id=53dfac76&", function () {
      api.rerender('53dfac76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotFoundGuard.vue"
export default component.exports